import Link, { LinkProps } from "next/link";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CommsorLinkProps extends Partial<LinkProps> {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string; // optional: if provided, we'll render a Link
  download?: boolean;
  target?: string;
}

export default function CommsorLink({
  children,
  href,
  onClick,
  download,
  target,
  className,
  ...props
}: CommsorLinkProps) {
  const style = cn("text-brand underline underline-offset-3 cursor-pointer body-lg", className);

  if (href) {
    // If download is true, render a plain <a> tag that includes the download attribute. this is to handle downloading files
    if (download) {
      return (
        <a
          href={href}
          className={style}
          target="_blank"
          rel="noopener noreferrer"
          download
          {...props}
        >
          {children}
        </a>
      );
    }
    return (
      <Link
        href={href}
        {...props}
        className={style}
        target={target ?? "_blank"}
        rel="noopener noreferrer"
      >
        {children}
      </Link>
    );
  }

  return (
    <button className={style} onClick={onClick}>
      {children}
    </button>
  );
}
